/** @jsx jsx */
import React from "react";
import { jsx, Box } from "theme-ui";

const CardContainer = ({ children, ...props }) => (
    <Box
      {...props}
      sx={{
        variant: "borders.card",
      }}
    >
      {children}
    </Box>
);

export default CardContainer;
